if(!customElements.get('util-accordion')) {
    class UtilAccordion extends HTMLElement {
      constructor() {
        super();
        var self = this;
        var expandMultiple = this.dataset.expandMultiple=='true';
        var firstExpanded = this.dataset.firstExpanded=='true';
        var filter = this.querySelector('.category-filter');
        this.accordions = this.querySelectorAll('.accordion');
        
        if (filter) {
          filter.addEventListener('change', ()=>{
            this.accordions.forEach(function(accordionItem){
              accordionItem.style.display = accordionItem.dataset.category==filter.value ? '' : 'none';
            });
          });
        }
        
        this.accordions.forEach(function(accordionItem, index) {
          var button = accordionItem.querySelector('button[aria-expanded]');
          var panel = accordionItem.querySelector('[role="region"]');
          
          // Expand first accordion on page load if firstExpanded is true
          if (firstExpanded && index === 0) {
            button.setAttribute('aria-expanded', 'true');
            accordionItem.classList.add('open');
            $s.expand(panel);
          }
          
          button.addEventListener('click', function(event) {
            if (button.getAttribute('aria-expanded')=='true') {
              button.setAttribute('aria-expanded', 'false');
              accordionItem.classList.remove('open');
              $s.collapse(panel);
            } else {
              button.setAttribute('aria-expanded', 'true');
              accordionItem.classList.add('open');
              $s.expand(panel);
              if (!expandMultiple) {
                //close other panels
                var allButtonsExpanded = self.querySelectorAll((filter ? '[data-category="'+accordionItem.dataset.category+'"] ' : '') + 'button[aria-expanded="true"]');
                allButtonsExpanded.forEach(function(buttonExpanded) {
                  if (buttonExpanded!=button) {
                    var thisAccordion = buttonExpanded.closest('.accordion');
                    var thisPanel = thisAccordion.querySelector('[role="region"]');
                    buttonExpanded.setAttribute('aria-expanded', 'false');
                    thisAccordion.classList.remove('open');
                    $s.collapse(thisPanel);
                  }
                })
              }
            }
          });
        });
      }
  
    }
    customElements.define('util-accordion', UtilAccordion);
  
  }